import service from './axios';

// 获取安全设置
export const getSecuritySettings = () => service.get('/manage/settings/security');

// 保存安全设置
export const saveSecuritySettings = (data) => service.post('/manage/settings/security', data);

// 获取所有设置
export const getAllSettings = () => service.get('/manage/settings');

// 批量保存设置
export const batchSetSettings = (settings) => service.post('/manage/settings/batch', { settings });
